class MetricManager {
  constructor(data) {
    this.data = data
    this.activeCustomerCount = data.active_customers_count ?? 0
    this.unique_users = data.unique_users ?? 0
    this.repeat_users = data.repeat_users ?? 0
    this.activeEmployeesAppointmentsCount = data.active_employees_appointments_count ?? 0
    this.inactiveEmployeesAppointmentsCount = data.inactive_employees_appointments_count ?? 0
    this.activeDependentsAppointmentsCount = data.active_dependents_appointments_count ?? 0
    this.inactiveDependentsAppointmentsCount = data.inactive_dependents_appointments_count ?? 0
    this.activeEmployeesUpcomingAppointmentsCount = data.active_employees_upcoming_appointments_count ?? 0
    this.activeDependentsUpcomingAppointmentsCount = data.active_dependents_upcoming_appointments_count ?? 0 
    this.totalHealthChecksCompleted = this.getTotalHealthChecksCompleted()
    this.healthCheckAvailedPercentage = this.getHealthCheckAvailedPercentage()
    this.totalSplitCount = this.totalSplitCount()
    this.donutGraphData = this.donutGraphData()
    this.partners = this.partners()
    this.successMetric = data.success_metric
  }

  getTotalHealthChecksCompleted() {
    return (this.activeEmployeesAppointmentsCount + this.activeDependentsAppointmentsCount + this.inactiveEmployeesAppointmentsCount + this.inactiveDependentsAppointmentsCount)
  }

  getHealthCheckAvailedPercentage() {
    return this.activeCustomerCount ? Math.round((this.activeEmployeesAppointmentsCount / this.activeCustomerCount) * 100) : 0
  }

  floorPercentage(numerator, denominator) {
    return Math.round((numerator / denominator) * 100)
  }

  totalSplitCount() {
    let totalSplit = 0
    let splitData = this.data.split
    Object.keys(splitData).forEach((hashKey) => {
      totalSplit += splitData[hashKey]
    })

    return totalSplit
  }

  donutGraphData() {
    let result = []
    const { center, home, camp } = this.data.split

    result.push({
      text: 'Walk-In',
      number: center || 0,
      percentage: center ? this.floorPercentage(center, this.totalSplitCount) : 0,
      color: center ? '#5A8BED' : '#E5E8F0',
    })
    result.push({
      text: 'Home Collection',
      number: home || 0,
      percentage: home ? this.floorPercentage(home, this.totalSplitCount) : 0,
      color: home ? '#3FCB7F' : '#E5E8F0',
    })
    result.push({
      text: 'OnSite',
      number: camp || 0,
      percentage: camp ? this.floorPercentage(camp, this.totalSplitCount) : 0,
      color: camp ? '#FFB500' : '#E5E8F0',
    })

    return result
  }

  partners() {
    return this.data.providers.map((item, key) => ({
      partner_name: item[0],
      employee_count: item[1],
    }))
  }
}

export default MetricManager
